import { render, staticRenderFns } from "./listmth.vue?vue&type=template&id=12d84197&scoped=true"
import script from "./listmth.vue?vue&type=script&lang=js"
export * from "./listmth.vue?vue&type=script&lang=js"
import style0 from "./listmth.vue?vue&type=style&index=0&id=12d84197&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d84197",
  null
  
)

export default component.exports